/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activate_ButtonInputs */

const en_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate License`)
};

const fr_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer la Licence`)
};

const de_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lizenz aktivieren`)
};

const it_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva licenza`)
};

const ru_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активировать лицензию`)
};

const es_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar licencia`)
};

const zh_cn2_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活许可证`)
};

const ja_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライセンスを有効化`)
};

const hi_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइसेंस सक्रिय करें`)
};

const pt_pt2_login_offline_activate_button = /** @type {(inputs: Login_Offline_Activate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar licença`)
};

/**
* | output |
* | --- |
* | "Activate License" |
*
* @param {Login_Offline_Activate_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activate_button = /** @type {((inputs?: Login_Offline_Activate_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activate_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activate_button(inputs)
	if (locale === "de") return de_login_offline_activate_button(inputs)
	if (locale === "it") return it_login_offline_activate_button(inputs)
	if (locale === "ru") return ru_login_offline_activate_button(inputs)
	if (locale === "es") return es_login_offline_activate_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activate_button(inputs)
	if (locale === "ja") return ja_login_offline_activate_button(inputs)
	if (locale === "hi") return hi_login_offline_activate_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activate_button(inputs)
	return en_login_offline_activate_button(inputs)
});